import React from "react";
import styles from "./IR330C.module.scss";

const IR330CFormEnd = () => {
  return (
    <div className={styles.irdFormDetails}>
      <div className={styles.formBox}>
        <div className="page-title-2">
          <div className={styles.boxInlineData}>
          <div className={styles.title}>Employer</div>
          <div className={styles.details}>
            <p className="mb-0">
              Do not send this form to Inland Revenue.{" "}<br/>
                You must keep this completed IR330 form for your business records for 7 years following the last wage payment you make to the employee.<br/>
                When an employee gives you this form, you must change their tax code, even if you have been given different advice in the past.
            </p>
          </div>
        </div>
        </div>
      </div>
    </div>
  );
};

export default IR330CFormEnd;
